
(function () {
    "use strict";
    var sdk = window.adobe_dc_sdk,
        options = sdk.launchOptions,
        thisScript = document.getElementById("adobe_dc_sdk_launcher");

    options.verb = thisScript.getAttribute("data-verb") || "createpdf";
    /*
    if (options.env !== 'dev') {
        options.ims_scope += ',update_profile.first_name,update_profile.last_name';
    }
     */

    options.ims_client_id = {
        prod: 'dc-prod-virgoweb',
        stage: 'dc-stage-virgoweb',
        dev: 'dc-dev-virgoweb',
        localdev: 'dc-local-virgoweb'
    }[options.env];

    window.adobeid = {
        uses_redirect_mode: true,
        client_id: options.ims_client_id,
        scope: options.ims_scope,
        locale: sdk.dom.getLocale()
    };
}());
